import "./styles.scss";

import { useTranslation } from "react-i18next";

import PlaceholderPage from "components/PlaceholderPage";
import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import { InvoicesTable, InvoicesTiles } from "./components";
import useResponsive from "libs/helpers/useResponsive";

import { useApp } from "context/app";
import { useInvoices } from "context/client/invoices";

const mainClass = "invoices-content";

const InvoicesContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { init_loading, init_data_length } = useInvoices();

  const { websites } = useApp();

  const actions = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  return (
    <DashboardContentLayout
      header={
        websites?.length > 0
          ? {
              label: t("Payments"),
              description: t(
                "Summary of your payments and a preview of issued invoices.",
              ),
            }
          : null
      }
      loading={init_loading}
      actions={actions}
    >
      {init_data_length > 0 || websites?.length > 0 ? (
        <div className={mainClass}>
          {!max.lg ? <InvoicesTable /> : <InvoicesTiles />}
        </div>
      ) : (
        <PlaceholderPage
          title={t("Add your website to Webinity")}
          text={t(
            "Just a few simple steps away from peace of mind with managing your website or store. Let us take care of your website, and you enjoy the peace and time to grow your business.",
          )}
          button={{
            label: t("Add website"),
            href: "/websites/new",
          }}
        />
      )}
    </DashboardContentLayout>
  );
};

export default InvoicesContent;
